import { parseServerDate } from "./dateTime.ts";

/** Compatibility for callers that use Date#getTime to check validity. */
export const parseSessionDate = (value: string | number) => parseServerDate(value) ?? new Date(NaN);
